/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

function filterSortLists() {
  const keepOrder = [
    'price-ascending',
    'price-descending',
    'created-descending'
  ];

  document.querySelectorAll('.collection__sort__options ul').forEach(list => {
    const itemsByValue = new Map();
    const selectedValue =
      list.querySelector('input.collection__sort__input:checked')?.value;

    list.querySelectorAll('li.collection__filter-tag').forEach(li => {
      const input = li.querySelector('input.collection__sort__input');
      if (input) itemsByValue.set(input.value, li);
    });

    const currentValues = [...list.querySelectorAll('input.collection__sort__input')].map(i => i.value);
    const alreadyFiltered =
      currentValues.length === keepOrder.length &&
      keepOrder.every((value, index) => currentValues[index] === value);

    if (alreadyFiltered) return;

    list.innerHTML = '';

    keepOrder.forEach(value => {
      const item = itemsByValue.get(value);
      if (item) list.appendChild(item);
    });

    const finalValue = keepOrder.includes(selectedValue)
      ? selectedValue
      : 'created-descending';

    const finalInput = list.querySelector(`input.collection__sort__input[value="${finalValue}"]`);
    if (finalInput) finalInput.checked = true;
  });
}

document.addEventListener('DOMContentLoaded', filterSortLists);

const observer = new MutationObserver(() => {
  filterSortLists();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
